export enum SettingsType {
  classifications = "/settings/classifications",
  clients = "/settings/acds",
  emailaccounts = "/system-settings/emailaccounts",
  groups = "/system-settings/groups",
  grouprules = "/system-settings/grouprules",
  teams = "/settings/teams",
  transferForms = "/settings/transferforms",
  systemAccounts = "/settings/systemaccounts",
  users = "/settings/users",
  extractAccountData = "/system-settings/accountdataextractions",
}

export enum SettingsAction {
  create = "create",
  delete = "delete",
  edit = "edit",
  list = "list",
}

export enum SettingsListTab {
  list = "list",
  history = "history",
}

export type SettingsParams = {
  type: SettingsType;
  action:SettingsAction;
  id?: string;
};

export interface ResultsTableRowData {
  id: number|null;
  data: any;
}